<template>
    <modal :show="show" v-on:update:show="handleModalClose">
        <template slot="header">
            <h5 class="modal-title">New Voicemailbox</h5>
        </template>

        <template>
            <form>
                <div class="row">
                    <div class="col">
                        <base-input label="Name"
                                    type="text"
                                    placeholder="Enter name"
                                    v-model="name"
                                    name="name"
                                    v-validate="'required'"
                                    required
                                    :error="getError('name')"
                                    @input="handleNameInputChange"
                        >
                            <small slot="helperText" id="nameHelp" class="form-text text-muted">This will be used
                                throughout
                                the
                                portal to identify this voicemailbox.
                            </small>
                        </base-input>
                    </div>
                </div>
            </form>
        </template>


        <template slot="footer">
            <base-button type="primary" native-type="submit" @click.prevent="validate"
                         :loading="saving"> Save changes
            </base-button>
            <base-button type="secondary" @click.native="$emit('update:show', false)">Close</base-button>
        </template>
    </modal>
</template>

<script>
    import Modal from "../../components/Modal";

    export default {
        name: "NewVoicemailboxModal",
        components: {
            Modal,
        },
        props: {
            show: Boolean,
        },
        data() {
            return {
                name: null,
                saving: false,
            }
        },
        methods: {
            getError(fieldName) {
                return this.errors.first(fieldName)
            }
            ,
            validate() {
                this.$validator.validateAll().then(isValid => {
                    if (isValid) {
                        this.save()
                    }
                })
            },
            handleNameInputChange(value) {
                this.name = value.replace(/[#,."'/\\`~ :;}{|$&%^?+*]/g, '');
            },
            handleModalClose(value) {
                this.$emit('update:show', value);
            },
            save() {
                this.saving = true;
                this.$store.dispatch('voicemail/create', {name: this.name}).then(() => {
                    this.$emit('update:show', false);
                    this.$emit('created');

                    this.$notify({
                        message: 'Voicemailbox created!',
                        type: "success",
                        iconClass: "fal fa-save",
                        title: "Saved!"
                    });
                }).catch(() => {
                    this.$notify({
                        position: "bottom-right",
                        message: 'Failed to create voicemailbox',
                        type: "error",
                        iconClass: "fal fa-times",
                        title: "Error!"
                    });
                }).finally(() => {
                    this.saving = false;
                });
            },
        }
    }
</script>

<style scoped>

</style>